import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import AuthenticationProvider from './authenticationContext'
import IntlProviderWrapper from './intlProviderWrapper'
import { LocaleProvider } from './localeContext'
import MuiLocalizationProviderWrapper from './muiLocalizationProviderWrapper'
import { SiteDetailsProvider } from './siteDetailsContext'

const AppProviders = (props: React.PropsWithChildren) => {
  const queryClient = new QueryClient()
  return (
    <AuthenticationProvider>
      <LocaleProvider>
        <IntlProviderWrapper>
          <MuiLocalizationProviderWrapper>
            <QueryClientProvider client={queryClient}>
              <SiteDetailsProvider>{props.children}</SiteDetailsProvider>
            </QueryClientProvider>
          </MuiLocalizationProviderWrapper>
        </IntlProviderWrapper>
      </LocaleProvider>
    </AuthenticationProvider>
  )
}

export default AppProviders
